

export enum OrderTrafficGeneration {
  inactive = 'INACTIVE',
  activeNoMarketing = 'ACTIVE_NO_MARKETING',
  activeWithMarketing = 'ACTIVE_WITH_MARKETING',
  marketingOnly = 'MARKETING_ONLY',
}
